import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AdList from '../components/AdList';
import axios from '../api';

const MyAds = () => {
  const [ads, setAds] = useState([]);
  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    document.title = 'آگهی‌های من | آگاه‌جو';
  }, []);

  useEffect(() => {
    axios.get('/ads/', { params: { mine: true, page_size: 200 } })
      .then(res => {
        const data = res.data;
        setAds(Array.isArray(data) ? data : (data.results ?? []));
        setLoading(false);
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status === 404) {
            setAds([]);
            setLoading(false);
          } else if (err.response.status === 401) {
            setAds([]);
            setLoading(false);
          } else {
            setAds([]);
            setLoading(false);
          }
        } else {
          setAds([]);
          setLoading(false);
        }
      });
  }, []);

  return (
    <Box sx={{ direction: 'rtl', px: 2, py: 6 }}>
      <Typography variant="h4" fontWeight={800} color="primary" align="right" gutterBottom>
        آگهی‌های من
      </Typography>
      {loading ? (
        <Typography align="center">در حال بارگذاری...</Typography>
      ) : ads.length === 0 ? (
        <Typography align="center">شما هیچ آگهی ثبت نکرده‌اید.</Typography>
      ) : (
        <AdList ads={ads} />
      )}
    </Box>
  );
};

export default MyAds;
